import type { FaireProductEntity } from "../../entity_types/product";

export const p_dqbr0dw6: FaireProductEntity = {
  token: "p_dqbr0dw6",
  type: "product",
  name: "Clara | Growing Candle, flower seed-label, eco-friendly",
  brandToken: "b_4l6t3x36",
  brandName: "Hyggelight | The Growing Candle ®",
  imageUrl:
    "https://cdn.faire.com/fastly/110c177ced9ba628d9572ec800f80a1258f9a42d8c1b86329e374e914a56536a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/582672436a8014e7541eb01f96a2494fd2ec7e6d5171808215cbb2efcd9b987c.jpeg",
    "https://cdn.faire.com/fastly/5d165aaea27bd2ec7f3dc69e954046268e642277d51db10a6a0513a2965c3ad2.jpeg",
    "https://cdn.faire.com/fastly/1ee738e63cea16553707ef5ed66d8afcea00bdee2694ae9f3170910427596336.jpeg",
    "https://cdn.faire.com/fastly/361ef432d560abf86c1a2126b640e06e9a0411a19f141a5980618695b043d37d.jpeg",
    "https://cdn.faire.com/fastly/496171a10161669fee676eea9674a1c0396fe22d659d293b1b40bc4e4282a0e3.jpeg",
    "https://cdn.faire.com/fastly/9e5b87520760be08b61135617956f8a95998c17366f3314f8578f873c0098b13.webp",
    "https://cdn.faire.com/fastly/9945e6e93bea048dda5f457642a4e4d35c771014f49a1cc6e1438377995433be.webp",
    "https://cdn.faire.com/fastly/017c6df7b3807e3ddc43b2b49ab6eec84013f96249675eb69ff0edc468bc7365.webp",
    "https://cdn.faire.com/fastly/f23edac82e3b362422a09613ca70324af4dfc020c41b69651c23fe251cd04f18.webp",
    "https://cdn.faire.com/fastly/1feb8d0fcd2f0e709b1aea5bb17b2fdd54eaa5eb56194e6d0a32d937905174ba.png",
  ],
  priceDollars: 17,
  description:
    "All of our Growing Candles are 100% soy wax based + hand-poured into re-useable ceramic containers with non-toxic fragrance oils. Done with your candle? Plant the seed-embedded label into the empty container to grow flowers! \n\n• Floral Artwork w/Growing Candle® directions included.\n• Plastic-free packaging.\n• Specifications of “Clara” container:\n   - Color and Characteristics - White glazed ceramic pot with metallic gold finish.\n   - Dimensions - 3.5” x 3.5” x 3”.\n   - Volume - Approx.10oz (280ml).\n   - Weight - 1lbs, 2oz.\n• Wax: 100% soy wax with no added dyes or fillers.\n• Wick: Cotton with no added heavy metals.\n• Burn Time: 55 Hours.\n• Fragrances Include: Sandalwood + Vanilla, Coffee + Cream, Lavender, Mint + Eucalyptus, Cedarwood, Chai\n\nGreat for holiday gifts, bedroom decor, fall, christmas, christmas decor, halloween, halloween decor, holiday candles, coffee, eco-friendly, gifts, plant-lovers, B-Corporation, bookstore, back to school, cozy, and novelty gifts.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:59.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
